import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthenticationGuard } from "@bndes/bndes-ux4/bn-seguranca";
import { AgenteFinanceiroResolver } from 'src/app/shared/resolvers/agente-financeiro.resolver';

import { DominiosResolver } from 'src/app/shared/resolvers/dominios.resolver';
import { EscolhaModalidadeGuard } from 'src/app/interceptors/escolha-modalidade.guard';
import { LimiteHistoricoPesquisaComponent } from './limite-historico-pesquisa/limite-historico-pesquisa.component'

const routes: Routes = [
  {
    path: 'limite-historico',
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    data: { canReuse: false },
    resolve: {
      dominios: DominiosResolver
    },

    children: [
      {
        path: 'listagem',
        component:  LimiteHistoricoPesquisaComponent,
      },

    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LimiteHistoricoRoutingModule { }
